import styled from "@emotion/styled";
import React from "react";

import Container from "components/Container";
import ImageBar from "./sections/ImageBar";
import News from "./sections/News";
import Toolbox from "./sections/Toolbox";
import VideoBar from "./sections/VideoBar";
// import Articles from './sections/Articles';
import ScrollToTopButton from "components/ScrollToTopButton";
import SocialMedia from "components/SocialMedia";
import Advertisement from "./sections/Advertisement";
import Sidebar from "./Sidebar/Sidebar";

import media from "styles/media";
import vw from "styles/utils";

function Home() {
  return (
    <Root>
      <StyledContainer>
        <LeftCol>
          <News />
          <ImageBar />
          <Toolbox />
          <VideoBar />
          {/* <Articles /> */}
          <Advertisement />
        </LeftCol>
        <RightCol>
          <Sidebar />
        </RightCol>
      </StyledContainer>
      <SocialMedia />
      <ScrollToTopButton />
    </Root>
  );
}

const Root = styled.main``;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  ${vw("padding-top", 30, 30)}
  ${vw("padding-bottom", 50, 90)}

  @media ${media.desktop} {
    flex-direction: row;
  }
`;

const LeftCol = styled.div`
  @media ${media.desktop} {
    width: 66%;
  }
`;

const RightCol = styled.div`
  @media ${media.desktop} {
    width: 34%;
  }
`;

export default Home;
